import { ethers } from "ethers";
import FlowNFTBase from "./FlowNFTBase";
import { ConstantOutflowNFT__factory, } from "./typechain-types";
export default class ConstantOutflowNFT extends FlowNFTBase {
    constructor(address) {
        super(address);
        this.contract = new ethers.Contract(address, ConstantOutflowNFT__factory.abi);
    }
}
//# sourceMappingURL=ConstantOutflowNFT.js.map